import { EtatTacheService } from '../../../tache/shared/services/etatTache.service';
import { Component, OnInit, Input } from '@angular/core';
import { imgCardDrop } from '../../classes/animations';
import { EtatTache } from '../../../tache/shared/classes/etatTache';
import { FormControl } from '@angular/forms';
import { AclAccess } from '../../../configuration/shared/classes/acl_access';
import { AlertService } from '../../services/alert.service';
import { StorageService } from '../../services/storage.service';
import { TypeConvention } from '../../../infrastructure/shared/classes/type_convention';
import { TRANSLATE } from '../../classes/translatable';
import { Unite } from '../../../facturation/shared/classes/unite';
import { UniteService } from '../../../facturation/shared/services/unite.service';

@Component({
  selector: 'app-admin-list-unite',
  templateUrl: './admin-list-unite.component.html',
  styleUrls: ['./admin-list-unite.component.css'],
  animations: [imgCardDrop]
})
export class AdminListUniteComponent implements OnInit {

    unites: Unite[];
    newUnite = new Unite();
    selected = new FormControl(0);

    @Input()
    triggerReload: () => void;

    aclConfig: AclAccess;

    constructor(
        private uniteService: UniteService,
        private alertService: AlertService,
        private storageService: StorageService
    ) { }

    ngOnInit() {
        this.aclConfig  = new AclAccess(this.storageService.getAcl('configuration'));
        this.unites = [];
    }


    getUnites() {
        this.unites = [];
        this.uniteService.fetchUnites()
        .subscribe(retour => {
            if (retour.status === 200) {
                retour.data.forEach(element => {
                    this.unites.push(new Unite(element));
                });
            }
        });
    }


    selectTab(event: any) {
        this.selected.setValue(event);
        if (event === 1) {
            this.getUnites();
        }
    }

    insertUnite(unite: Unite) {
        this.uniteService.createUnite(unite)
        .subscribe(retour => {
            if (retour.status === 201) {
                this.newUnite = new Unite();
                this.alertService.success(TRANSLATE('Unité ajoutée avec succès'));
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    updateUnite(unite: Unite) {
        this.uniteService.updateUnite(unite.uni_id, unite)
        .subscribe(retour => {
            if (retour.status === 201) {
                this.alertService.success(TRANSLATE('Unité modifiée avec succès'));
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    deleteUnite(unite: Unite) {
        this.uniteService.deleteUnite(unite.uni_id)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Unité supprimée avec succès'));
                this.getUnites();
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

}
